import { Tooltip } from "@mui/material";

export const UTILIZATION_POPUP_HOVER_DELAY_MS = 250;

const UtilizationAmountHover = ({ popup, ariaLabel, children }) => (
  <Tooltip
    title={popup}
    arrow
    placement="top"
    enterDelay={UTILIZATION_POPUP_HOVER_DELAY_MS}
    leaveDelay={80}
    componentsProps={{
      tooltip: {
        className: "utilization-budget-info__tooltip",
      },
    }}
  >
    <span
      className="utilization-budget-info__value-trigger"
      aria-label={ariaLabel}
      onClick={(event) => event.stopPropagation()}
    >
      {children}
    </span>
  </Tooltip>
);

export default UtilizationAmountHover;
